import React from 'react';
import { TDropdownItem } from './dropdown.model';
import styles from './dropdown.module.scss';
import DropdownContainer from './dropdown-container';

const DropdownItem = (props: TDropdownItem) => {
  const { children, onClick } = props;
  return (
    <div className={styles.dropdownItem} onClick={onClick}>
      {children}
    </div>
  );
};

export default DropdownItem;

DropdownContainer.displayName = 'Dropdown.Item';
